// Blog.js (Component)
import React, { useEffect, useRef } from 'react';
import './blog.scss';
import { Link } from 'react-router-dom';
import Header from '../landing/Header/Header';
import Footer from '../landing/footer/Footer';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Loader from '../../utils/loader';
import useBlogData from '../../hooks/useBlogData'; // Import the custom hook
import ResponsiveImage from '../common/ResponsiveImage';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
gsap.registerPlugin(ScrollTrigger);

const Blog = () => {
    const { categories, loading, posts, page, hasMore, selectedCategory, setPage, setSelectedCategory, resetPosts, CAT_NAME } = useBlogData();

    const textRef = useRef(null);

    useEffect(() => {
        const tl = gsap.timeline();

        gsap.set(textRef.current, {
            clipPath: "inset(0% 100% 0% 0%)",
            opacity: 1,
        });

        tl.to(textRef.current, {
            clipPath: "inset(0% 0% 0% 0%)",
            duration: 1,
            ease: "power2.out",
        });
    }, []);


    useEffect(() => {
        gsap.from(".breadvrumbcnt, .breadvrumbcntactive", {
            opacity: 0,
            y: 10,
            duration: 0.6,
            stagger: 0.2,
            ease: "power2.out",
        });
    }, []);


    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const breadcrumbSchema = {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        "itemListElement": [
            {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://tomi.com/"
            },
            {
                "@type": "ListItem",
                "position": 2,
                "name": "Blog",
                "item": "https://tomi.com/blog"
            }
        ]
    };

    useEffect(() => {
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.innerHTML = JSON.stringify(breadcrumbSchema);
        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, []);


    useEffect(() => {
        document.title = "Blog - Stay up to date with the latetst from tomi";

        const metaDescription = document.querySelector("meta[name='description']");
        if (metaDescription) {
            metaDescription.setAttribute(
                "content",
                "Explore tomi's blog for in-depth articles on the future of the web3 landscape, technology updates, project insights, and more."
            );
        } else {
            const newMeta = document.createElement("meta");
            newMeta.name = "description";
            newMeta.setAttribute(
                "content",
                "Explore tomi's blog for in-depth articles on the future of the web3 landscape, technology updates, project insights, and more."
            );
            document.head.appendChild(newMeta);
        }
    }, []);



    return (
        <>
            {/* {loading && <Loader />} */}
            <Header />

            <section id='home' className="mainbanner">
                <img src='/assets/bgblog.png' alt='img' className='img-fluid bgblog' />
                <div className='formobile d-none'>
                    <img src='/assets/blogmbl.png' alt='img' className='bannermbl img-fluid ' />
                </div>
                <div className='custom-container'>
                    <div className='maincontent'>
                        <nav aria-label="breadcrumb">
                            <Breadcrumb className="breadcrumbprnt">
                                <Breadcrumb.Item className="breadvrumbcnt" href="/">
                                    Home
                                </Breadcrumb.Item>
                                <Breadcrumb.Item className="breadvrumbcntactive">
                                    Blog
                                </Breadcrumb.Item>

                            </Breadcrumb>
                        </nav>
                        <p className='black' ref={textRef}>Latest Blogs</p>
                    </div>
                </div>
            </section>

            <section className="mainspeciality">
                <img src='/assets/bolgbottomshade.png' alt='img' className='img-fluid bottomshade' />
                <div className="custom-container">
                    <div className='maincardssection'>
                        <div className='mainthreebutton'>
                            <div className='left'>
                                <a>Filters</a>
                            </div>
                            <div className='right'>
                                <button onClick={() => { resetPosts(selectedCategory); setSelectedCategory('') }}>
                                    All
                                </button>
                                {categories.map((category) => (
                                    <button key={category.id} onClick={() => { resetPosts(category.id); setSelectedCategory(category.id) }}>
                                        {category.name}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="parentcards">
                        {loading && <>
                            {
                                [...Array(10)].map((_, id) => (
                                    <div key={id} className='innercard skeleton-card'>
                                        <div className={id === 0 ? 'mainimagefirst' : 'mainimage'}>
                                            <Skeleton width="100%" height={200} className="skeleton-img" />
                                        </div>
                                        <Skeleton width="100%" height={25} className="skeleton-button" />
                                        <Skeleton width="100%" height={20} className="skeleton-text" />
                                    </div>
                                ))
                            }
                        </>}
                    </div>
                    <div className='parentcards'>
                        {posts.length > 0 ? (
                            posts.map((post, id) => (
                                <Link key={post.id} to={`/blogdetail/${post.slug}/${selectedCategory || 'null'}`} className='innercard'>
                                    <div className={id === 0 ? 'mainimagefirst' : 'mainimage'}>
                                        <ResponsiveImage post={post} className='img-fluid innerimage' />
                                    </div>
                                    <button className='news'>{CAT_NAME[post.categories?.[0]]}</button>
                                    <p className='custom-text-controller' dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
                                </Link>
                            ))
                        ) : (
                            !loading && <p className='text-center'>No posts available.</p>
                        )}
                    </div>

                    {hasMore && !loading && (
                        <button className='seemore secondarybtn' onClick={() => setPage((prevPage) => prevPage + 1)}>See More</button>
                    )}
                </div>
            </section>
            <Footer />
        </>
    );
};

export default Blog;
